export const IFRAME_READY_MESSAGE_TYPE = "pregao-iframe-ready";
export const IFRAME_LAYOUT_PULSE_MESSAGE_TYPE = "pregao-iframe-layout-pulse";

export function injectScriptIntoHtml(html, script) {
  const safeHtml = typeof html === "string" ? html : "";
  if (!safeHtml || !script) return safeHtml;

  if (/<head[\s>]/i.test(safeHtml)) {
    return safeHtml.replace(/<head(\s[^>]*)?>/i, match => `${match}\n${script}`);
  }

  if (/<body[\s>]/i.test(safeHtml)) {
    return safeHtml.replace(/<body(\s[^>]*)?>/i, match => `${match}\n${script}`);
  }

  return `${script}\n${safeHtml}`;
}

export function createIframeReadyBootstrap({ origin, token }) {
  const safeOrigin = JSON.stringify(origin || "");
  const safeToken = JSON.stringify(token);

  return [
    "<script>",
    "(function(){",
    "  if (window.__pregaoIframeReadyInstalled) return;",
    "  window.__pregaoIframeReadyInstalled = true;",
    `  var origin = ${safeOrigin};`,
    `  var token = ${safeToken};`,
    "  var sent = false;",
    "  var scheduled = false;",
    "  function notify(reason) {",
    "    if (sent) return;",
    "    sent = true;",
    "    try {",
    `      window.parent.postMessage({ tipo: '${IFRAME_READY_MESSAGE_TYPE}', origem: origin, token: token, reason: reason || 'paint' }, '*');`,
    "    } catch (e) {}",
    "  }",
    "  function afterPaint() {",
    "    if (scheduled || sent) return;",
    "    scheduled = true;",
    "    try {",
    "      window.requestAnimationFrame(function(){",
    "        window.requestAnimationFrame(function(){",
    "          notify('paint');",
    "        });",
    "      });",
    "    } catch (error) {",
    "      setTimeout(function(){ notify('fallback'); }, 0);",
    "    }",
    "  }",
    "  function afterFontsAndPaint() {",
    "    try {",
    "      if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {",
    "        var settled = false;",
    "        var finalize = function(){",
    "          if (settled) return;",
    "          settled = true;",
    "          afterPaint();",
    "        };",
    "        document.fonts.ready.then(finalize).catch(finalize);",
    "        setTimeout(finalize, 800);",
    "        return;",
    "      }",
    "    } catch (error) {}",
    "    afterPaint();",
    "  }",
    "  window.addEventListener('message', function(event){",
    "    var payload = event && event.data ? event.data : null;",
    `    if (!payload || payload.tipo !== '${IFRAME_LAYOUT_PULSE_MESSAGE_TYPE}') return;`,
    "    try {",
    "      window.dispatchEvent(new Event('resize'));",
    "      window.requestAnimationFrame(function(){",
    "        window.requestAnimationFrame(function(){",
    "          window.dispatchEvent(new Event('resize'));",
    "        });",
    "      });",
    "    } catch (error) {}",
    "  });",
    "  if (document.readyState === 'complete') {",
    "    afterFontsAndPaint();",
    "  } else {",
    "    window.addEventListener('load', afterFontsAndPaint, { once: true });",
    "    setTimeout(function(){",
      "      if (!sent) notify('timeout');",
    "    }, 1500);",
    "  }",
    "})();",
    "</scr" + "ipt>"
  ].join("\n");
}
